import { api } from "./api";

export const deleteItemApi = (params) => {
  return api.post(`/store/address/delete`, JSON.stringify(params));
};
export const storeAddressCreateApi = (params) => {
  return api.post(`/store/address/add`, JSON.stringify(params));
};
export const storePersonalCreateApi = (params) => {
  return api.post(`/store/personalDetails/add`, JSON.stringify(params));
};
export const storeFirmCreateApi = (params) => {
  return api.post(`/store/firmDetails/add`, JSON.stringify(params));
};
export const storePartnerCreateApi = (params) => {
  return api.post(`/fofo/partnerDetails/add`, JSON.stringify(params));
};
export const storeAgreementCreateApi = (params) => {
  return api.post(`/store/storeAgreement/add`, JSON.stringify(params));
};
export const storePaymentCreateApi = (params) => {
   return api.post(`/cpos/store/payment/add`, JSON.stringify(params));
};
export const storeDrugCreateApi = (params) => {
  return api.post(`/store/drugLicenseDetails/add`, JSON.stringify(params));
};
export const storeLOICreateApi = (params) => {
  return api.post(`/cpos/store/termsAndCondtion/add`, JSON.stringify(params));
};
export const getFofoStoreTypesApi = () => {
  return api.get(`/fofo/storeType/getAll`);
};
export const getFofoFirmTypesApi = () => {
  return api.get(`/fofo/firmType/getAll`);
};
export const storeAddressUpdateApi = (params) => {
  return api.post(`/store/address/update`, JSON.stringify(params));
};
export const storeTableApi = (params) => {
  const searchParams = params?.filterData?.inputValue
    ? `&searchColumn=${params?.filterData?.selectColumn}&searchValue=${params?.filterData?.inputValue}`
    : "";

  return api.get(
    `/storelist/get/?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}&sortBy=${params?.filterData?.sort_by}&sortOrder=${params?.filterData?.sort_order}${searchParams}`,
    JSON.stringify(params)
  );
};
export const storeViewApi = (params) => {
  return api.get(`/store/getById?store_id=${params}`, JSON.stringify(params));
};

export const addStrInfraApi = (params) => {
  return api.post(`/store/excution/addInfraDetails`, JSON.stringify(params));
};
export const addStrbrandApi = (params) => {
  return api.post(`/store/excution/addbrandingDetails`, JSON.stringify(params));
};
export const addStrBrandSoftwareApi = (params) => {
  return api.post(
    `/store/excution/addbrandingDetailsAndSoftwareDetails`,
    JSON.stringify(params)
  );
};
export const addStrAccApi = (params) => {
  return api.post(
    `/store/excution/addAccountingDetails`,
    JSON.stringify(params)
  );
};
export const addStrDispatchApi = (params) => {
  return api.post(`/store/excution/addDispatchDetails`, JSON.stringify(params));
};
export const addStrOpeningApi = (params) => {
  return api.post(`/store/excution/addOpeningData`, JSON.stringify(params));
};
export const addStrFollowUpApi = (params) => {
  return api.post(`/store/excution/addfollowupData`, JSON.stringify(params));
};
export const strFollowUpGetApi = (params) => {
  return api.get(
    `/store/excution/getfollowupData?store_id=${params}`,
    JSON.stringify(params)
  );
};
export const strExeGetApi = (params) => {
  return api.get(`/store/excution/getByStoreId?store_id=${params}`);
};
export const storeUpdateDrugApi = (params) => {
  return api.post(`/store/drugLicenseDetails/update`, JSON.stringify(params));
};
export const getLoiHtmlDataApi = (params) => {
  return api.post(`/cpos/app/getLOIHtmlData`, JSON.stringify(params));
};
export const getLoiPdfApi = (params) => {
  return api.post(`/cpos/app/getLOIPdf`, JSON.stringify(params));
};
export const createFofoStoreTypeApi = (params) => {
  return api.post(`/fofo/storeType/add`, JSON.stringify(params));
};
export const updateFofoStoreTypeApi = (params) => {
  return api.post(`/fofo/storeType/update`, JSON.stringify(params));
};
export const deleteFofoStoreTypeApi = (params) => {
  return api.post(`/fofo/storeType/delete`, JSON.stringify(params));
};
export const createFofoFirmTypeApi = (params) => {
  return api.post(`/fofo/firmType/add`, JSON.stringify(params));
};
export const updateFofoFirmTypeApi = (params) => {
  return api.post(`/fofo/firmType/update`, JSON.stringify(params));
};
export const deleteFofoFirmTypeApi = (params) => {
  return api.post(`/fofo/firmType/delete`, JSON.stringify(params));
};
/**
 * GET /store/auto-generate-store-code
 *
 * Builds the store code from the store's own details; all four params are
 * required and the response is { data: { store_code } }.
 * Used when a store is approved without a code already on record.
 */
export const autoGenerateStoreCodeApi = ({
  server_name,
  store_type,
  store_name,
  state,
} = {}) => {
  const params = new URLSearchParams();
  if (server_name) params.append("server_name", server_name);
  if (store_type) params.append("store_type", store_type);
  if (store_name) params.append("store_name", store_name);
  if (state) params.append("state", state);
  return api.get(`/store/auto-generate-store-code?${params.toString()}`);
};

/**
 * Store approval decisions — POST /store/approve and /store/reject.
 *
 * One endpoint pair serves every stage; the stage is chosen by which flag the
 * body carries:
 *
 *   Store Details  is_approve_location      / is_reject_location
 *   LOI            is_loi_approved          / is_loi_rejected
 *   Drug License   is_approve_dl            / is_reject_dl
 *   Payment        is_francise_fee_approved / is_francise_fee_rejected
 *
 * (The franchise-fee keys are misspelled server-side; they are sent verbatim.)
 *
 * Both return the resulting flags, and setting one clears its opposite, so the
 * response is the authoritative state to render from.
 */
export const storeApproveApi = (params) => {
  return api.post(`/store/approve`, JSON.stringify(params));
};
export const storeRejectApi = (params) => {
  return api.post(`/store/reject`, JSON.stringify(params));
};
